// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"77a981c8","99":"24553a39","109":"0a6f1c83","139":"02d7c679","141":"c794b56d","212":"f1630163","325":"5976481c","453":"2eefa076","475":"d36612d1","716":"6f8dcc2f","743":"940f57a3","806":"db757068","971":"b4de6bfd"}[chunkId] + ".chunk.js";
};